import React from 'react';
import styled from 'styled-components';
import Text from '@ingka/text';
import Button from '@ingka/button';
import membershipCard from '@ingka/ssr-icon/paths/membership-card';
import useTranslation from '../hooks/useTranslation';

const LoginPromptContainer = styled.div`
  border: 1px solid #d8d8d8;
  padding: 2rem;
  border-radius: 4px;
  width: 100%;
  max-width: 640px;
  box-sizing: border-box;
  margin: 1rem 0 2rem 0;
`;

const StyledPromptTitle = styled(Text)`
  &&& {
    margin-top: 0;
  }
`;

const StyledPromptText = styled(Text)`
  &&& {
    margin-bottom: 2rem;
    display: block;
  }
`;

interface LoginPromptCardProps {
  linkTo: string;
}

const LoginPromptCard: React.FC<LoginPromptCardProps> = ({ linkTo }) => {
  const { t } = useTranslation();

  return (
    <LoginPromptContainer data-testid="login-prompt-card">
      <StyledPromptTitle tagName="h3" textStyle="Heading.M">
        {t('customerInformation.loginPromptCard.title')}
      </StyledPromptTitle>
      <StyledPromptText tagName="p" textStyle="Body.L">
        {t('customerInformation.loginPromptCard.text')}
      </StyledPromptText>
      <Button
        type="primary"
        small
        text={t('customerInformation.loginPromptCard.buttonText')}
        ssrIcon={membershipCard}
        iconPosition="leading"
        href={linkTo}
        aria-label={t('customerInformation.loginPromptCard.ariaLabelButton')}
      />
    </LoginPromptContainer>
  );
};

export default LoginPromptCard;
